import limitService from "@/services/limit";
import {
  getLimitTypeLabelKey,
  getTimeLimitLabelKey,
  normalizeLimitData,
} from "@/utils/limitHelpers";

export default {
  data() {
    return {
      limits: [],
      limitsLoading: false,
    };
  },
  computed: {
    selectedLimitHint() {
      if (!this.selectedLimit) return "";

      const hasCompanyId =
        this.selectedLimit.company_id !== null &&
        this.selectedLimit.company_id !== undefined;
      const hasRestaurantId =
        this.selectedLimit.restaurant_id !== null &&
        this.selectedLimit.restaurant_id !== undefined;
      const restaurantName = this.toLatin(this.$store.state.restaurant?.name || '');
      const companyName = this.toLatin(this.$store.state.company?.name || '');

      if (hasCompanyId && hasRestaurantId) {
        return restaurantName
          ? this.$t("limit_credit_scope_combined_named", { restaurant: restaurantName })
          : this.$t("limit_credit_scope_combined");
      }
      if (hasCompanyId && !hasRestaurantId) {
        return companyName
          ? this.$t("limit_credit_scope_company_named", { company: companyName })
          : this.$t("limit_credit_scope_company");
      }
      if (!hasCompanyId && hasRestaurantId) {
        return restaurantName
          ? this.$t("limit_credit_scope_restaurant_named", { restaurant: restaurantName })
          : this.$t("limit_credit_scope_restaurant");
      }

      return "";
    },
    limitOptions() {
      const companyId = this.companyId;
      const companyRestaurants = this.companyRestaurants || [];

      const belongsToCompany = (limit) => limit.company_id === companyId;
      const belongsToCompanyRestaurant = (limit) =>
        !limit.company_id &&
        companyRestaurants.some((r) => r.id === limit.restaurant_id);

      return this.limits
        .filter((limit) => belongsToCompany(limit) || belongsToCompanyRestaurant(limit))
        .map((limit) => {
          const typeKey = getLimitTypeLabelKey(limit.params?.limit_definition?.active);
          const timeKey = getTimeLimitLabelKey(limit.params?.timing?.active);
          const details = [this.$t(typeKey), this.$t(timeKey)]
            .filter(Boolean)
            .join(" / ");
          return {
            text: details ? `${limit.name} (${details})` : limit.name,
            value: limit.id,
            ...limit,
          };
        });
    },
  },
  methods: {
    async fetchLimits(restaurantIds = []) {
      if (!this.companyId) return;
      this.limitsLoading = true;
      try {
        const params = { company_id: this.companyId };
        if (restaurantIds.length > 0) {
          params.restaurant_id = restaurantIds;
        }
        const allData = await limitService.getAllLimits(params);
        this.limits = allData
          .filter((l) => l.state === "active")
          .map((l) => normalizeLimitData(l));
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_loading_limits"));
      } finally {
        this.limitsLoading = false;
      }
    },
  },
};
